import { useState, ChangeEvent, useMemo, useEffect, useRef } from "react";
import { ScreenProps } from "../../types/ScreenTypes";
import {
  EndCallButton,
  Row,
  Timer,
  TextArea,
  Wrapper,
  CallButton,
} from "../Components";
import { KeypadPopover } from "../Keypad";
import { EndCallSvg } from "../Icons";
import { BATTLESHIP, SLINKY } from "../../utils/colors";
import { formatPhoneNumber } from "../../utils/phoneNumberUtils";
import { END_CALL } from "../../constants/buttonIds";
import axios from "axios";
import { urls } from "../api/api";

function CallingScreen({
  cti,
  dialNumber,
  incomingNumber,
  notes,
  setNotes,
  setIsCallRecorded,
  callDurationString,
  handleCallEnded,
  handleKeypadScreen,
  direction,
}: ScreenProps) {
  const userInformation = localStorage.getItem("userInformation");
  const UserInfo = userInformation ? JSON.parse(userInformation) : {};
  const [callconnect, setCallConnect] = useState("PENDING");
  const [isCallActive, setIsCallActive] = useState(false);
  const [userrefresh, setUsererfresh] = useState(false);
  const intervalRef = useRef<any>(null);
  const isCallEndedRef = useRef(false);
  const [isLiveCallConnected, setIsLiveCallConnected] = useState(false);

  // useEffect(() => {
  //   const fetchCallLog = async () => {
  //     try {
  //       const form = new FormData();
  //       form.append("authcode", UserInfo.authcode);

  //       const response = await axios.post(urls.calllogV2, form);

  //       setIsCallRecorded(response.data);
  //     } catch (error) {
  //       console.error("Error fetching call log:", error);
  //     }
  //   };

  //   fetchCallLog();
  // }, [UserInfo.authcode, setIsCallRecorded]);

  const handleNotes = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setNotes(event.target.value);
  };

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    intervalRef.current = setInterval(async () => {
      if (isCallEndedRef.current) return;
      try {
        const response = await axios.get(urls.liveCall, {
          params: { authcode: UserInfo.authcode },
        });

        if (response.data.live_calls?.length > 0) {
          setCallConnect("CONNECT");
          sessionStorage.setItem(
            "livedata",
            response.data.live_calls[0].sid_id
          );
          setIsCallActive(true);
          setIsLiveCallConnected(true);
        }

        if (
          callconnect === "CONNECT" &&
          response.data.live_calls.length === 0
        ) {
          handleCallEnded();

          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      } catch (error) {
        console.error("Error fetching call status:", error);
      }
    }, 2000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [callconnect]);

  const onEndCall = async () => {
    try {
      isCallEndedRef.current = true;
      clearInterval(intervalRef.current);
      intervalRef.current = null;

      const callSid = sessionStorage.getItem("livedata");

      if (!callSid) {
        console.warn("No live data found in sessionStorage.");
        return;
      }

      const form = new FormData();
      form.append("authcode", UserInfo.authcode);
      form.append("callsid", callSid);
      const response = await axios.post(urls.disconnect, form);

      cti.callEnded({
        callEndStatus: "COMPLETED",
      });

      handleCallEnded();
    } catch (error) {
      console.error("Error in onEndCall:", error);
    }
  };

useEffect(() => {
  if (!isLiveCallConnected) {
    const timeoutId = setTimeout(() => {
      setUsererfresh(true);
    }, 20000);

    return () => clearTimeout(timeoutId);
  }
}, [isLiveCallConnected]);

  function KeyboardClick() {
     localStorage.removeItem("incomingContactName");
        localStorage.removeItem("outgoing");
        localStorage.removeItem("isFromWindows");
        localStorage.removeItem("incomingCall");
        localStorage.removeItem("INCOMING_CALL");
        localStorage.removeItem("thirdParty");
    handleKeypadScreen();
  }

  const content = useMemo(() => {
    return <KeypadPopover />;
  }, []);

  return (
    <Wrapper>
      <div style={{ textAlign: "center" }}>
        <img src="" />
        <h2>
          Call with{" "}
          {formatPhoneNumber(
            direction === "INBOUND" ? incomingNumber : dialNumber
          )}
        </h2>
        <Timer>{callDurationString}</Timer>
        {/* <Timer
          style={{
            width: "65px",
            alignItems: "center",
            padding: "5px",
            borderRadius: "10px",
            background: "blue",
            color: "white",
            display: "inline-flex",
          }}
          onClick={KeyboardClick}
        >
          Refresh
        </Timer> */}
      </div>
      <Row>
        {/* <CallButton
          use="primary"
          onClick={KeyboardClick}
          aria-label="outgoing-call"
        >
          Refresh
        </CallButton> */}

        {/* <EndCallButton
          use="primary"
          onClick={onEndCall}
          aria-label="end-call"
          data-test-id={END_CALL}
          disabled={!isCallActive}
        >
          {EndCallSvg}
        </EndCallButton> */}
        {userrefresh ? (
          <CallButton
            use="primary"
            onClick={KeyboardClick}
            aria-label="outgoing-call"
          >
            Refresh
          </CallButton>
        ) : (
          <EndCallButton
            use="primary"
            onClick={onEndCall}
            aria-label="end-call"
            data-test-id={END_CALL}
            disabled={!isCallActive}
          >
            {EndCallSvg}
          </EndCallButton>
        )}
      </Row>
      <br />
      <hr style={{ margin: "0 30px", border: `0.8px solid ${BATTLESHIP}` }} />
      <br />
      <Row>Notes</Row>
      <Row>
        <TextArea
          id="callingnotes"
          rows={10}
          value={notes}
          onChange={handleNotes}
          placeholder="Enter notes from your call ..."
        />
      </Row>
    </Wrapper>
  );
}

export default CallingScreen;
